/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccessToken,
  Courier,
  CourierPackage,
  CourierSettings,
  CourierUser,
  Invoice,
  MailOption,
  Mailbox,
  NewCourierPackage,
  NewCourierUser,
  NewInvoice,
  NewMailbox,
  NewReferral,
  NewRole,
  NewRoleMapping,
  Referral,
  Role,
  RoleMapping,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
} from '../models/index';
import {
    AccessTokenFromJSON,
    AccessTokenToJSON,
    CourierFromJSON,
    CourierToJSON,
    CourierPackageFromJSON,
    CourierPackageToJSON,
    CourierSettingsFromJSON,
    CourierSettingsToJSON,
    CourierUserFromJSON,
    CourierUserToJSON,
    InvoiceFromJSON,
    InvoiceToJSON,
    MailOptionFromJSON,
    MailOptionToJSON,
    MailboxFromJSON,
    MailboxToJSON,
    NewCourierPackageFromJSON,
    NewCourierPackageToJSON,
    NewCourierUserFromJSON,
    NewCourierUserToJSON,
    NewInvoiceFromJSON,
    NewInvoiceToJSON,
    NewMailboxFromJSON,
    NewMailboxToJSON,
    NewReferralFromJSON,
    NewReferralToJSON,
    NewRoleFromJSON,
    NewRoleToJSON,
    NewRoleMappingFromJSON,
    NewRoleMappingToJSON,
    ReferralFromJSON,
    ReferralToJSON,
    RoleFromJSON,
    RoleToJSON,
    RoleMappingFromJSON,
    RoleMappingToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
} from '../models/index';

export interface ReferralCountRequest {
    where?: string;
}

export interface ReferralCreateRequest {
    data?: NewReferral;
}

export interface ReferralCreateChangeStreamGetReferralsChangeStreamRequest {
    options?: string;
}

export interface ReferralCreateChangeStreamPostReferralsChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface ReferralDeleteByIdRequest {
    id: string;
}

export interface ReferralExistsGetReferralsidExistsRequest {
    id: string;
}

export interface ReferralExistsHeadReferralsidRequest {
    id: string;
}

export interface ReferralFindRequest {
    filter?: string;
}

export interface ReferralFindByIdRequest {
    id: string;
    filter?: string;
}

export interface ReferralFindOneRequest {
    filter?: string;
}

export interface ReferralPatchOrCreateRequest {
    data?: Referral;
}

export interface ReferralPrototypeCountRefereeAccessTokensRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefereeCourierPackagesRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefereeInvoicesRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefereeMailboxesRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefereeReferrerRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefereeRoleMappingsRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefereeRolesRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefererAccessTokensRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefererCourierPackagesRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefererInvoicesRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefererMailboxesRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefererReferrerRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefererRoleMappingsRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCountRefererRolesRequest {
    id: string;
    where?: string;
}

export interface ReferralPrototypeCreateCourierCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface ReferralPrototypeCreateCourierMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface ReferralPrototypeCreateRefereeAccessTokensRequest {
    id: string;
    data?: AccessToken;
}

export interface ReferralPrototypeCreateRefereeCourierPackagesRequest {
    id: string;
    data?: NewCourierPackage;
}

export interface ReferralPrototypeCreateRefereeInvoicesRequest {
    id: string;
    data?: NewInvoice;
}

export interface ReferralPrototypeCreateRefereeMailboxesRequest {
    id: string;
    data?: NewMailbox;
}

export interface ReferralPrototypeCreateRefereeReferrerRequest {
    id: string;
    data?: NewCourierUser;
}

export interface ReferralPrototypeCreateRefereeRoleMappingsRequest {
    id: string;
    data?: NewRoleMapping;
}

export interface ReferralPrototypeCreateRefereeRolesRequest {
    id: string;
    data?: NewRole;
}

export interface ReferralPrototypeCreateRefererAccessTokensRequest {
    id: string;
    data?: AccessToken;
}

export interface ReferralPrototypeCreateRefererCourierPackagesRequest {
    id: string;
    data?: NewCourierPackage;
}

export interface ReferralPrototypeCreateRefererInvoicesRequest {
    id: string;
    data?: NewInvoice;
}

export interface ReferralPrototypeCreateRefererMailboxesRequest {
    id: string;
    data?: NewMailbox;
}

export interface ReferralPrototypeCreateRefererReferrerRequest {
    id: string;
    data?: NewCourierUser;
}

export interface ReferralPrototypeCreateRefererRoleMappingsRequest {
    id: string;
    data?: NewRoleMapping;
}

export interface ReferralPrototypeCreateRefererRolesRequest {
    id: string;
    data?: NewRole;
}

export interface ReferralPrototypeDeleteRefereeAccessTokensRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefereeCourierPackagesRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefereeInvoicesRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefereeMailboxesRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefereeReferrerRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefereeRoleMappingsRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefereeRolesRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefererAccessTokensRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefererCourierPackagesRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefererInvoicesRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefererMailboxesRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefererReferrerRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefererRoleMappingsRequest {
    id: string;
}

export interface ReferralPrototypeDeleteRefererRolesRequest {
    id: string;
}

export interface ReferralPrototypeDestroyByIdRefereeAccessTokensRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefereeCourierPackagesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefereeInvoicesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefereeMailboxesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefereeReferrerRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefereeRoleMappingsRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefereeRolesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefererAccessTokensRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefererCourierPackagesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefererInvoicesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefererMailboxesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefererReferrerRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefererRoleMappingsRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyByIdRefererRolesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeDestroyCourierCourierSettingRequest {
    id: string;
}

export interface ReferralPrototypeDestroyCourierMailOptionRequest {
    id: string;
}

export interface ReferralPrototypeExistsRefereeRolesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeExistsRefererRolesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefereeAccessTokensRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefereeCourierPackagesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefereeInvoicesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefereeMailboxesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefereeReferrerRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefereeRoleMappingsRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefereeRolesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefererAccessTokensRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefererCourierPackagesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefererInvoicesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefererMailboxesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefererReferrerRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefererRoleMappingsRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeFindByIdRefererRolesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeGetCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface ReferralPrototypeGetCourierCourierSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface ReferralPrototypeGetCourierMailOptionRequest {
    id: string;
    refresh?: boolean;
}

export interface ReferralPrototypeGetRefereeRequest {
    id: string;
    refresh?: boolean;
}

export interface ReferralPrototypeGetRefereeAccessTokensRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefereeCourierPackagesRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefereeInvoicesRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefereeMailboxesRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefereeReferrerRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefereeRoleMappingsRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefereeRolesRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefererRequest {
    id: string;
    refresh?: boolean;
}

export interface ReferralPrototypeGetRefererAccessTokensRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefererCourierPackagesRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefererInvoicesRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefererMailboxesRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefererReferrerRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefererRoleMappingsRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeGetRefererRolesRequest {
    id: string;
    filter?: string;
}

export interface ReferralPrototypeLinkRefereeRolesRequest {
    id: string;
    fk: string;
    data?: RoleMapping;
}

export interface ReferralPrototypeLinkRefererRolesRequest {
    id: string;
    fk: string;
    data?: RoleMapping;
}

export interface ReferralPrototypePatchAttributesRequest {
    id: string;
    data?: Referral;
}

export interface ReferralPrototypeUnlinkRefereeRolesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeUnlinkRefererRolesRequest {
    id: string;
    fk: string;
}

export interface ReferralPrototypeUpdateByIdRefereeAccessTokensRequest {
    id: string;
    fk: string;
    data?: AccessToken;
}

export interface ReferralPrototypeUpdateByIdRefereeCourierPackagesRequest {
    id: string;
    fk: string;
    data?: CourierPackage;
}

export interface ReferralPrototypeUpdateByIdRefereeInvoicesRequest {
    id: string;
    fk: string;
    data?: Invoice;
}

export interface ReferralPrototypeUpdateByIdRefereeMailboxesRequest {
    id: string;
    fk: string;
    data?: Mailbox;
}

export interface ReferralPrototypeUpdateByIdRefereeReferrerRequest {
    id: string;
    fk: string;
    data?: CourierUser;
}

export interface ReferralPrototypeUpdateByIdRefereeRoleMappingsRequest {
    id: string;
    fk: string;
    data?: RoleMapping;
}

export interface ReferralPrototypeUpdateByIdRefereeRolesRequest {
    id: string;
    fk: string;
    data?: Role;
}

export interface ReferralPrototypeUpdateByIdRefererAccessTokensRequest {
    id: string;
    fk: string;
    data?: AccessToken;
}

export interface ReferralPrototypeUpdateByIdRefererCourierPackagesRequest {
    id: string;
    fk: string;
    data?: CourierPackage;
}

export interface ReferralPrototypeUpdateByIdRefererInvoicesRequest {
    id: string;
    fk: string;
    data?: Invoice;
}

export interface ReferralPrototypeUpdateByIdRefererMailboxesRequest {
    id: string;
    fk: string;
    data?: Mailbox;
}

export interface ReferralPrototypeUpdateByIdRefererReferrerRequest {
    id: string;
    fk: string;
    data?: CourierUser;
}

export interface ReferralPrototypeUpdateByIdRefererRoleMappingsRequest {
    id: string;
    fk: string;
    data?: RoleMapping;
}

export interface ReferralPrototypeUpdateByIdRefererRolesRequest {
    id: string;
    fk: string;
    data?: Role;
}

export interface ReferralPrototypeUpdateCourierCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface ReferralPrototypeUpdateCourierMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface ReferralReplaceByIdPostReferralsidReplaceRequest {
    id: string;
    data?: Referral;
}

export interface ReferralReplaceByIdPutReferralsidRequest {
    id: string;
    data?: Referral;
}

export interface ReferralReplaceOrCreatePostReferralsReplaceOrCreateRequest {
    data?: Referral;
}

export interface ReferralReplaceOrCreatePutReferralsRequest {
    data?: Referral;
}

export interface ReferralUpdateAllRequest {
    where?: string;
    data?: Referral;
}

export interface ReferralUpsertWithWhereRequest {
    where?: string;
    data?: Referral;
}

/**
 * 
 */
export class ReferralApi extends runtime.BaseAPI {

    /**
     * Count instances of the model matched by where from the data source.
     */
    async referralCountRaw(requestParameters: ReferralCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async referralCount(requestParameters: ReferralCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async referralCreateRaw(requestParameters: ReferralCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Referral>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewReferralToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async referralCreate(requestParameters: ReferralCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Referral> {
        const response = await this.referralCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async referralCreateChangeStreamGetReferralsChangeStreamRaw(requestParameters: ReferralCreateChangeStreamGetReferralsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async referralCreateChangeStreamGetReferralsChangeStream(requestParameters: ReferralCreateChangeStreamGetReferralsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.referralCreateChangeStreamGetReferralsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async referralCreateChangeStreamPostReferralsChangeStreamRaw(requestParameters: ReferralCreateChangeStreamPostReferralsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async referralCreateChangeStreamPostReferralsChangeStream(requestParameters: ReferralCreateChangeStreamPostReferralsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.referralCreateChangeStreamPostReferralsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async referralDeleteByIdRaw(requestParameters: ReferralDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async referralDeleteById(requestParameters: ReferralDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.referralDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async referralExistsGetReferralsidExistsRaw(requestParameters: ReferralExistsGetReferralsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralExistsGetReferralsidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async referralExistsGetReferralsidExists(requestParameters: ReferralExistsGetReferralsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.referralExistsGetReferralsidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async referralExistsHeadReferralsidRaw(requestParameters: ReferralExistsHeadReferralsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralExistsHeadReferralsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async referralExistsHeadReferralsid(requestParameters: ReferralExistsHeadReferralsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.referralExistsHeadReferralsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async referralFindRaw(requestParameters: ReferralFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Referral>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReferralFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async referralFind(requestParameters: ReferralFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Referral>> {
        const response = await this.referralFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async referralFindByIdRaw(requestParameters: ReferralFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Referral>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async referralFindById(requestParameters: ReferralFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Referral> {
        const response = await this.referralFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async referralFindOneRaw(requestParameters: ReferralFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Referral>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async referralFindOne(requestParameters: ReferralFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Referral> {
        const response = await this.referralFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async referralPatchOrCreateRaw(requestParameters: ReferralPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Referral>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async referralPatchOrCreate(requestParameters: ReferralPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Referral> {
        const response = await this.referralPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts accessTokens of CourierUser.
     */
    async referralPrototypeCountRefereeAccessTokensRaw(requestParameters: ReferralPrototypeCountRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefereeAccessTokens().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/accessTokens/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts accessTokens of CourierUser.
     */
    async referralPrototypeCountRefereeAccessTokens(requestParameters: ReferralPrototypeCountRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefereeAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts courierPackages of CourierUser.
     */
    async referralPrototypeCountRefereeCourierPackagesRaw(requestParameters: ReferralPrototypeCountRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefereeCourierPackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/courierPackages/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts courierPackages of CourierUser.
     */
    async referralPrototypeCountRefereeCourierPackages(requestParameters: ReferralPrototypeCountRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefereeCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts invoices of CourierUser.
     */
    async referralPrototypeCountRefereeInvoicesRaw(requestParameters: ReferralPrototypeCountRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefereeInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/invoices/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts invoices of CourierUser.
     */
    async referralPrototypeCountRefereeInvoices(requestParameters: ReferralPrototypeCountRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefereeInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts mailboxes of CourierUser.
     */
    async referralPrototypeCountRefereeMailboxesRaw(requestParameters: ReferralPrototypeCountRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefereeMailboxes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/mailboxes/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts mailboxes of CourierUser.
     */
    async referralPrototypeCountRefereeMailboxes(requestParameters: ReferralPrototypeCountRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefereeMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts referrer of CourierUser.
     */
    async referralPrototypeCountRefereeReferrerRaw(requestParameters: ReferralPrototypeCountRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefereeReferrer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/referrer/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts referrer of CourierUser.
     */
    async referralPrototypeCountRefereeReferrer(requestParameters: ReferralPrototypeCountRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefereeReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts roleMappings of CourierUser.
     */
    async referralPrototypeCountRefereeRoleMappingsRaw(requestParameters: ReferralPrototypeCountRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefereeRoleMappings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/roleMappings/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts roleMappings of CourierUser.
     */
    async referralPrototypeCountRefereeRoleMappings(requestParameters: ReferralPrototypeCountRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefereeRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts roles of CourierUser.
     */
    async referralPrototypeCountRefereeRolesRaw(requestParameters: ReferralPrototypeCountRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefereeRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/roles/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts roles of CourierUser.
     */
    async referralPrototypeCountRefereeRoles(requestParameters: ReferralPrototypeCountRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefereeRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts accessTokens of CourierUser.
     */
    async referralPrototypeCountRefererAccessTokensRaw(requestParameters: ReferralPrototypeCountRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefererAccessTokens().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/accessTokens/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts accessTokens of CourierUser.
     */
    async referralPrototypeCountRefererAccessTokens(requestParameters: ReferralPrototypeCountRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefererAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts courierPackages of CourierUser.
     */
    async referralPrototypeCountRefererCourierPackagesRaw(requestParameters: ReferralPrototypeCountRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefererCourierPackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/courierPackages/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts courierPackages of CourierUser.
     */
    async referralPrototypeCountRefererCourierPackages(requestParameters: ReferralPrototypeCountRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefererCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts invoices of CourierUser.
     */
    async referralPrototypeCountRefererInvoicesRaw(requestParameters: ReferralPrototypeCountRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefererInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/invoices/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts invoices of CourierUser.
     */
    async referralPrototypeCountRefererInvoices(requestParameters: ReferralPrototypeCountRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefererInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts mailboxes of CourierUser.
     */
    async referralPrototypeCountRefererMailboxesRaw(requestParameters: ReferralPrototypeCountRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefererMailboxes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/mailboxes/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts mailboxes of CourierUser.
     */
    async referralPrototypeCountRefererMailboxes(requestParameters: ReferralPrototypeCountRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefererMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts referrer of CourierUser.
     */
    async referralPrototypeCountRefererReferrerRaw(requestParameters: ReferralPrototypeCountRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefererReferrer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/referrer/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts referrer of CourierUser.
     */
    async referralPrototypeCountRefererReferrer(requestParameters: ReferralPrototypeCountRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefererReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts roleMappings of CourierUser.
     */
    async referralPrototypeCountRefererRoleMappingsRaw(requestParameters: ReferralPrototypeCountRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefererRoleMappings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/roleMappings/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts roleMappings of CourierUser.
     */
    async referralPrototypeCountRefererRoleMappings(requestParameters: ReferralPrototypeCountRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefererRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts roles of CourierUser.
     */
    async referralPrototypeCountRefererRolesRaw(requestParameters: ReferralPrototypeCountRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCountRefererRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/roles/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts roles of CourierUser.
     */
    async referralPrototypeCountRefererRoles(requestParameters: ReferralPrototypeCountRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.referralPrototypeCountRefererRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async referralPrototypeCreateCourierCourierSettingRaw(requestParameters: ReferralPrototypeCreateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async referralPrototypeCreateCourierCourierSetting(requestParameters: ReferralPrototypeCreateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.referralPrototypeCreateCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async referralPrototypeCreateCourierMailOptionRaw(requestParameters: ReferralPrototypeCreateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async referralPrototypeCreateCourierMailOption(requestParameters: ReferralPrototypeCreateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.referralPrototypeCreateCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in accessTokens of this model.
     */
    async referralPrototypeCreateRefereeAccessTokensRaw(requestParameters: ReferralPrototypeCreateRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefereeAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessTokenToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in accessTokens of this model.
     */
    async referralPrototypeCreateRefereeAccessTokens(requestParameters: ReferralPrototypeCreateRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.referralPrototypeCreateRefereeAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierPackages of this model.
     */
    async referralPrototypeCreateRefereeCourierPackagesRaw(requestParameters: ReferralPrototypeCreateRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefereeCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierPackageToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierPackages of this model.
     */
    async referralPrototypeCreateRefereeCourierPackages(requestParameters: ReferralPrototypeCreateRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.referralPrototypeCreateRefereeCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in invoices of this model.
     */
    async referralPrototypeCreateRefereeInvoicesRaw(requestParameters: ReferralPrototypeCreateRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefereeInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewInvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in invoices of this model.
     */
    async referralPrototypeCreateRefereeInvoices(requestParameters: ReferralPrototypeCreateRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.referralPrototypeCreateRefereeInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in mailboxes of this model.
     */
    async referralPrototypeCreateRefereeMailboxesRaw(requestParameters: ReferralPrototypeCreateRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Mailbox>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefereeMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/mailboxes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewMailboxToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in mailboxes of this model.
     */
    async referralPrototypeCreateRefereeMailboxes(requestParameters: ReferralPrototypeCreateRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Mailbox> {
        const response = await this.referralPrototypeCreateRefereeMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in referrer of this model.
     */
    async referralPrototypeCreateRefereeReferrerRaw(requestParameters: ReferralPrototypeCreateRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefereeReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierUserToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in referrer of this model.
     */
    async referralPrototypeCreateRefereeReferrer(requestParameters: ReferralPrototypeCreateRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.referralPrototypeCreateRefereeReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in roleMappings of this model.
     */
    async referralPrototypeCreateRefereeRoleMappingsRaw(requestParameters: ReferralPrototypeCreateRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefereeRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in roleMappings of this model.
     */
    async referralPrototypeCreateRefereeRoleMappings(requestParameters: ReferralPrototypeCreateRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.referralPrototypeCreateRefereeRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in roles of this model.
     */
    async referralPrototypeCreateRefereeRolesRaw(requestParameters: ReferralPrototypeCreateRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefereeRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRoleToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in roles of this model.
     */
    async referralPrototypeCreateRefereeRoles(requestParameters: ReferralPrototypeCreateRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.referralPrototypeCreateRefereeRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in accessTokens of this model.
     */
    async referralPrototypeCreateRefererAccessTokensRaw(requestParameters: ReferralPrototypeCreateRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefererAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessTokenToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in accessTokens of this model.
     */
    async referralPrototypeCreateRefererAccessTokens(requestParameters: ReferralPrototypeCreateRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.referralPrototypeCreateRefererAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierPackages of this model.
     */
    async referralPrototypeCreateRefererCourierPackagesRaw(requestParameters: ReferralPrototypeCreateRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefererCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierPackageToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierPackages of this model.
     */
    async referralPrototypeCreateRefererCourierPackages(requestParameters: ReferralPrototypeCreateRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.referralPrototypeCreateRefererCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in invoices of this model.
     */
    async referralPrototypeCreateRefererInvoicesRaw(requestParameters: ReferralPrototypeCreateRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefererInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewInvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in invoices of this model.
     */
    async referralPrototypeCreateRefererInvoices(requestParameters: ReferralPrototypeCreateRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.referralPrototypeCreateRefererInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in mailboxes of this model.
     */
    async referralPrototypeCreateRefererMailboxesRaw(requestParameters: ReferralPrototypeCreateRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Mailbox>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefererMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/mailboxes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewMailboxToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in mailboxes of this model.
     */
    async referralPrototypeCreateRefererMailboxes(requestParameters: ReferralPrototypeCreateRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Mailbox> {
        const response = await this.referralPrototypeCreateRefererMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in referrer of this model.
     */
    async referralPrototypeCreateRefererReferrerRaw(requestParameters: ReferralPrototypeCreateRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefererReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierUserToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in referrer of this model.
     */
    async referralPrototypeCreateRefererReferrer(requestParameters: ReferralPrototypeCreateRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.referralPrototypeCreateRefererReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in roleMappings of this model.
     */
    async referralPrototypeCreateRefererRoleMappingsRaw(requestParameters: ReferralPrototypeCreateRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefererRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in roleMappings of this model.
     */
    async referralPrototypeCreateRefererRoleMappings(requestParameters: ReferralPrototypeCreateRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.referralPrototypeCreateRefererRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in roles of this model.
     */
    async referralPrototypeCreateRefererRolesRaw(requestParameters: ReferralPrototypeCreateRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeCreateRefererRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRoleToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in roles of this model.
     */
    async referralPrototypeCreateRefererRoles(requestParameters: ReferralPrototypeCreateRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.referralPrototypeCreateRefererRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes all accessTokens of this model.
     */
    async referralPrototypeDeleteRefereeAccessTokensRaw(requestParameters: ReferralPrototypeDeleteRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefereeAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all accessTokens of this model.
     */
    async referralPrototypeDeleteRefereeAccessTokens(requestParameters: ReferralPrototypeDeleteRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefereeAccessTokensRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all courierPackages of this model.
     */
    async referralPrototypeDeleteRefereeCourierPackagesRaw(requestParameters: ReferralPrototypeDeleteRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefereeCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all courierPackages of this model.
     */
    async referralPrototypeDeleteRefereeCourierPackages(requestParameters: ReferralPrototypeDeleteRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefereeCourierPackagesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all invoices of this model.
     */
    async referralPrototypeDeleteRefereeInvoicesRaw(requestParameters: ReferralPrototypeDeleteRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefereeInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all invoices of this model.
     */
    async referralPrototypeDeleteRefereeInvoices(requestParameters: ReferralPrototypeDeleteRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefereeInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all mailboxes of this model.
     */
    async referralPrototypeDeleteRefereeMailboxesRaw(requestParameters: ReferralPrototypeDeleteRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefereeMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/mailboxes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all mailboxes of this model.
     */
    async referralPrototypeDeleteRefereeMailboxes(requestParameters: ReferralPrototypeDeleteRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefereeMailboxesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all referrer of this model.
     */
    async referralPrototypeDeleteRefereeReferrerRaw(requestParameters: ReferralPrototypeDeleteRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefereeReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all referrer of this model.
     */
    async referralPrototypeDeleteRefereeReferrer(requestParameters: ReferralPrototypeDeleteRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefereeReferrerRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all roleMappings of this model.
     */
    async referralPrototypeDeleteRefereeRoleMappingsRaw(requestParameters: ReferralPrototypeDeleteRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefereeRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all roleMappings of this model.
     */
    async referralPrototypeDeleteRefereeRoleMappings(requestParameters: ReferralPrototypeDeleteRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefereeRoleMappingsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all roles of this model.
     */
    async referralPrototypeDeleteRefereeRolesRaw(requestParameters: ReferralPrototypeDeleteRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefereeRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all roles of this model.
     */
    async referralPrototypeDeleteRefereeRoles(requestParameters: ReferralPrototypeDeleteRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefereeRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all accessTokens of this model.
     */
    async referralPrototypeDeleteRefererAccessTokensRaw(requestParameters: ReferralPrototypeDeleteRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefererAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all accessTokens of this model.
     */
    async referralPrototypeDeleteRefererAccessTokens(requestParameters: ReferralPrototypeDeleteRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefererAccessTokensRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all courierPackages of this model.
     */
    async referralPrototypeDeleteRefererCourierPackagesRaw(requestParameters: ReferralPrototypeDeleteRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefererCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all courierPackages of this model.
     */
    async referralPrototypeDeleteRefererCourierPackages(requestParameters: ReferralPrototypeDeleteRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefererCourierPackagesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all invoices of this model.
     */
    async referralPrototypeDeleteRefererInvoicesRaw(requestParameters: ReferralPrototypeDeleteRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefererInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all invoices of this model.
     */
    async referralPrototypeDeleteRefererInvoices(requestParameters: ReferralPrototypeDeleteRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefererInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all mailboxes of this model.
     */
    async referralPrototypeDeleteRefererMailboxesRaw(requestParameters: ReferralPrototypeDeleteRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefererMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/mailboxes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all mailboxes of this model.
     */
    async referralPrototypeDeleteRefererMailboxes(requestParameters: ReferralPrototypeDeleteRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefererMailboxesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all referrer of this model.
     */
    async referralPrototypeDeleteRefererReferrerRaw(requestParameters: ReferralPrototypeDeleteRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefererReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all referrer of this model.
     */
    async referralPrototypeDeleteRefererReferrer(requestParameters: ReferralPrototypeDeleteRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefererReferrerRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all roleMappings of this model.
     */
    async referralPrototypeDeleteRefererRoleMappingsRaw(requestParameters: ReferralPrototypeDeleteRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefererRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all roleMappings of this model.
     */
    async referralPrototypeDeleteRefererRoleMappings(requestParameters: ReferralPrototypeDeleteRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefererRoleMappingsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all roles of this model.
     */
    async referralPrototypeDeleteRefererRolesRaw(requestParameters: ReferralPrototypeDeleteRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDeleteRefererRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all roles of this model.
     */
    async referralPrototypeDeleteRefererRoles(requestParameters: ReferralPrototypeDeleteRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDeleteRefererRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for accessTokens.
     */
    async referralPrototypeDestroyByIdRefereeAccessTokensRaw(requestParameters: ReferralPrototypeDestroyByIdRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefereeAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefereeAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for accessTokens.
     */
    async referralPrototypeDestroyByIdRefereeAccessTokens(requestParameters: ReferralPrototypeDestroyByIdRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefereeAccessTokensRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for courierPackages.
     */
    async referralPrototypeDestroyByIdRefereeCourierPackagesRaw(requestParameters: ReferralPrototypeDestroyByIdRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefereeCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefereeCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for courierPackages.
     */
    async referralPrototypeDestroyByIdRefereeCourierPackages(requestParameters: ReferralPrototypeDestroyByIdRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefereeCourierPackagesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for invoices.
     */
    async referralPrototypeDestroyByIdRefereeInvoicesRaw(requestParameters: ReferralPrototypeDestroyByIdRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefereeInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefereeInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for invoices.
     */
    async referralPrototypeDestroyByIdRefereeInvoices(requestParameters: ReferralPrototypeDestroyByIdRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefereeInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for mailboxes.
     */
    async referralPrototypeDestroyByIdRefereeMailboxesRaw(requestParameters: ReferralPrototypeDestroyByIdRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefereeMailboxes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefereeMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/mailboxes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for mailboxes.
     */
    async referralPrototypeDestroyByIdRefereeMailboxes(requestParameters: ReferralPrototypeDestroyByIdRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefereeMailboxesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for referrer.
     */
    async referralPrototypeDestroyByIdRefereeReferrerRaw(requestParameters: ReferralPrototypeDestroyByIdRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefereeReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefereeReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for referrer.
     */
    async referralPrototypeDestroyByIdRefereeReferrer(requestParameters: ReferralPrototypeDestroyByIdRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefereeReferrerRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for roleMappings.
     */
    async referralPrototypeDestroyByIdRefereeRoleMappingsRaw(requestParameters: ReferralPrototypeDestroyByIdRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefereeRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefereeRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for roleMappings.
     */
    async referralPrototypeDestroyByIdRefereeRoleMappings(requestParameters: ReferralPrototypeDestroyByIdRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefereeRoleMappingsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for roles.
     */
    async referralPrototypeDestroyByIdRefereeRolesRaw(requestParameters: ReferralPrototypeDestroyByIdRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefereeRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefereeRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for roles.
     */
    async referralPrototypeDestroyByIdRefereeRoles(requestParameters: ReferralPrototypeDestroyByIdRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefereeRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for accessTokens.
     */
    async referralPrototypeDestroyByIdRefererAccessTokensRaw(requestParameters: ReferralPrototypeDestroyByIdRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefererAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefererAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for accessTokens.
     */
    async referralPrototypeDestroyByIdRefererAccessTokens(requestParameters: ReferralPrototypeDestroyByIdRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefererAccessTokensRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for courierPackages.
     */
    async referralPrototypeDestroyByIdRefererCourierPackagesRaw(requestParameters: ReferralPrototypeDestroyByIdRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefererCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefererCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for courierPackages.
     */
    async referralPrototypeDestroyByIdRefererCourierPackages(requestParameters: ReferralPrototypeDestroyByIdRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefererCourierPackagesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for invoices.
     */
    async referralPrototypeDestroyByIdRefererInvoicesRaw(requestParameters: ReferralPrototypeDestroyByIdRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefererInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefererInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for invoices.
     */
    async referralPrototypeDestroyByIdRefererInvoices(requestParameters: ReferralPrototypeDestroyByIdRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefererInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for mailboxes.
     */
    async referralPrototypeDestroyByIdRefererMailboxesRaw(requestParameters: ReferralPrototypeDestroyByIdRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefererMailboxes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefererMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/mailboxes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for mailboxes.
     */
    async referralPrototypeDestroyByIdRefererMailboxes(requestParameters: ReferralPrototypeDestroyByIdRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefererMailboxesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for referrer.
     */
    async referralPrototypeDestroyByIdRefererReferrerRaw(requestParameters: ReferralPrototypeDestroyByIdRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefererReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefererReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for referrer.
     */
    async referralPrototypeDestroyByIdRefererReferrer(requestParameters: ReferralPrototypeDestroyByIdRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefererReferrerRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for roleMappings.
     */
    async referralPrototypeDestroyByIdRefererRoleMappingsRaw(requestParameters: ReferralPrototypeDestroyByIdRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefererRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefererRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for roleMappings.
     */
    async referralPrototypeDestroyByIdRefererRoleMappings(requestParameters: ReferralPrototypeDestroyByIdRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefererRoleMappingsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for roles.
     */
    async referralPrototypeDestroyByIdRefererRolesRaw(requestParameters: ReferralPrototypeDestroyByIdRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyByIdRefererRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeDestroyByIdRefererRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for roles.
     */
    async referralPrototypeDestroyByIdRefererRoles(requestParameters: ReferralPrototypeDestroyByIdRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyByIdRefererRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async referralPrototypeDestroyCourierCourierSettingRaw(requestParameters: ReferralPrototypeDestroyCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async referralPrototypeDestroyCourierCourierSetting(requestParameters: ReferralPrototypeDestroyCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyCourierCourierSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes mailOption of this model.
     */
    async referralPrototypeDestroyCourierMailOptionRaw(requestParameters: ReferralPrototypeDestroyCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeDestroyCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes mailOption of this model.
     */
    async referralPrototypeDestroyCourierMailOption(requestParameters: ReferralPrototypeDestroyCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeDestroyCourierMailOptionRaw(requestParameters, initOverrides);
    }

    /**
     * Check the existence of roles relation to an item by id.
     */
    async referralPrototypeExistsRefereeRolesRaw(requestParameters: ReferralPrototypeExistsRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeExistsRefereeRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeExistsRefereeRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Check the existence of roles relation to an item by id.
     */
    async referralPrototypeExistsRefereeRoles(requestParameters: ReferralPrototypeExistsRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.referralPrototypeExistsRefereeRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check the existence of roles relation to an item by id.
     */
    async referralPrototypeExistsRefererRolesRaw(requestParameters: ReferralPrototypeExistsRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeExistsRefererRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeExistsRefererRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Check the existence of roles relation to an item by id.
     */
    async referralPrototypeExistsRefererRoles(requestParameters: ReferralPrototypeExistsRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.referralPrototypeExistsRefererRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for accessTokens.
     */
    async referralPrototypeFindByIdRefereeAccessTokensRaw(requestParameters: ReferralPrototypeFindByIdRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefereeAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefereeAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for accessTokens.
     */
    async referralPrototypeFindByIdRefereeAccessTokens(requestParameters: ReferralPrototypeFindByIdRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.referralPrototypeFindByIdRefereeAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for courierPackages.
     */
    async referralPrototypeFindByIdRefereeCourierPackagesRaw(requestParameters: ReferralPrototypeFindByIdRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefereeCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefereeCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for courierPackages.
     */
    async referralPrototypeFindByIdRefereeCourierPackages(requestParameters: ReferralPrototypeFindByIdRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.referralPrototypeFindByIdRefereeCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for invoices.
     */
    async referralPrototypeFindByIdRefereeInvoicesRaw(requestParameters: ReferralPrototypeFindByIdRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefereeInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefereeInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for invoices.
     */
    async referralPrototypeFindByIdRefereeInvoices(requestParameters: ReferralPrototypeFindByIdRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.referralPrototypeFindByIdRefereeInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for mailboxes.
     */
    async referralPrototypeFindByIdRefereeMailboxesRaw(requestParameters: ReferralPrototypeFindByIdRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Mailbox>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefereeMailboxes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefereeMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/mailboxes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for mailboxes.
     */
    async referralPrototypeFindByIdRefereeMailboxes(requestParameters: ReferralPrototypeFindByIdRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Mailbox> {
        const response = await this.referralPrototypeFindByIdRefereeMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for referrer.
     */
    async referralPrototypeFindByIdRefereeReferrerRaw(requestParameters: ReferralPrototypeFindByIdRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefereeReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefereeReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for referrer.
     */
    async referralPrototypeFindByIdRefereeReferrer(requestParameters: ReferralPrototypeFindByIdRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.referralPrototypeFindByIdRefereeReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for roleMappings.
     */
    async referralPrototypeFindByIdRefereeRoleMappingsRaw(requestParameters: ReferralPrototypeFindByIdRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefereeRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefereeRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for roleMappings.
     */
    async referralPrototypeFindByIdRefereeRoleMappings(requestParameters: ReferralPrototypeFindByIdRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.referralPrototypeFindByIdRefereeRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for roles.
     */
    async referralPrototypeFindByIdRefereeRolesRaw(requestParameters: ReferralPrototypeFindByIdRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefereeRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefereeRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for roles.
     */
    async referralPrototypeFindByIdRefereeRoles(requestParameters: ReferralPrototypeFindByIdRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.referralPrototypeFindByIdRefereeRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for accessTokens.
     */
    async referralPrototypeFindByIdRefererAccessTokensRaw(requestParameters: ReferralPrototypeFindByIdRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefererAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefererAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for accessTokens.
     */
    async referralPrototypeFindByIdRefererAccessTokens(requestParameters: ReferralPrototypeFindByIdRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.referralPrototypeFindByIdRefererAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for courierPackages.
     */
    async referralPrototypeFindByIdRefererCourierPackagesRaw(requestParameters: ReferralPrototypeFindByIdRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefererCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefererCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for courierPackages.
     */
    async referralPrototypeFindByIdRefererCourierPackages(requestParameters: ReferralPrototypeFindByIdRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.referralPrototypeFindByIdRefererCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for invoices.
     */
    async referralPrototypeFindByIdRefererInvoicesRaw(requestParameters: ReferralPrototypeFindByIdRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefererInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefererInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for invoices.
     */
    async referralPrototypeFindByIdRefererInvoices(requestParameters: ReferralPrototypeFindByIdRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.referralPrototypeFindByIdRefererInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for mailboxes.
     */
    async referralPrototypeFindByIdRefererMailboxesRaw(requestParameters: ReferralPrototypeFindByIdRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Mailbox>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefererMailboxes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefererMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/mailboxes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for mailboxes.
     */
    async referralPrototypeFindByIdRefererMailboxes(requestParameters: ReferralPrototypeFindByIdRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Mailbox> {
        const response = await this.referralPrototypeFindByIdRefererMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for referrer.
     */
    async referralPrototypeFindByIdRefererReferrerRaw(requestParameters: ReferralPrototypeFindByIdRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefererReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefererReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for referrer.
     */
    async referralPrototypeFindByIdRefererReferrer(requestParameters: ReferralPrototypeFindByIdRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.referralPrototypeFindByIdRefererReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for roleMappings.
     */
    async referralPrototypeFindByIdRefererRoleMappingsRaw(requestParameters: ReferralPrototypeFindByIdRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefererRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefererRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for roleMappings.
     */
    async referralPrototypeFindByIdRefererRoleMappings(requestParameters: ReferralPrototypeFindByIdRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.referralPrototypeFindByIdRefererRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for roles.
     */
    async referralPrototypeFindByIdRefererRolesRaw(requestParameters: ReferralPrototypeFindByIdRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeFindByIdRefererRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeFindByIdRefererRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for roles.
     */
    async referralPrototypeFindByIdRefererRoles(requestParameters: ReferralPrototypeFindByIdRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.referralPrototypeFindByIdRefererRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async referralPrototypeGetCourierRaw(requestParameters: ReferralPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async referralPrototypeGetCourier(requestParameters: ReferralPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.referralPrototypeGetCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async referralPrototypeGetCourierCourierSettingRaw(requestParameters: ReferralPrototypeGetCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async referralPrototypeGetCourierCourierSetting(requestParameters: ReferralPrototypeGetCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.referralPrototypeGetCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async referralPrototypeGetCourierMailOptionRaw(requestParameters: ReferralPrototypeGetCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async referralPrototypeGetCourierMailOption(requestParameters: ReferralPrototypeGetCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.referralPrototypeGetCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation referee.
     */
    async referralPrototypeGetRefereeRaw(requestParameters: ReferralPrototypeGetRefereeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetReferee().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation referee.
     */
    async referralPrototypeGetReferee(requestParameters: ReferralPrototypeGetRefereeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.referralPrototypeGetRefereeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries accessTokens of CourierUser.
     */
    async referralPrototypeGetRefereeAccessTokensRaw(requestParameters: ReferralPrototypeGetRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccessToken>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefereeAccessTokens().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccessTokenFromJSON));
    }

    /**
     * Queries accessTokens of CourierUser.
     */
    async referralPrototypeGetRefereeAccessTokens(requestParameters: ReferralPrototypeGetRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccessToken>> {
        const response = await this.referralPrototypeGetRefereeAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries courierPackages of CourierUser.
     */
    async referralPrototypeGetRefereeCourierPackagesRaw(requestParameters: ReferralPrototypeGetRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierPackage>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefereeCourierPackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierPackageFromJSON));
    }

    /**
     * Queries courierPackages of CourierUser.
     */
    async referralPrototypeGetRefereeCourierPackages(requestParameters: ReferralPrototypeGetRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierPackage>> {
        const response = await this.referralPrototypeGetRefereeCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries invoices of CourierUser.
     */
    async referralPrototypeGetRefereeInvoicesRaw(requestParameters: ReferralPrototypeGetRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Invoice>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefereeInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceFromJSON));
    }

    /**
     * Queries invoices of CourierUser.
     */
    async referralPrototypeGetRefereeInvoices(requestParameters: ReferralPrototypeGetRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Invoice>> {
        const response = await this.referralPrototypeGetRefereeInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries mailboxes of CourierUser.
     */
    async referralPrototypeGetRefereeMailboxesRaw(requestParameters: ReferralPrototypeGetRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Mailbox>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefereeMailboxes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/mailboxes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MailboxFromJSON));
    }

    /**
     * Queries mailboxes of CourierUser.
     */
    async referralPrototypeGetRefereeMailboxes(requestParameters: ReferralPrototypeGetRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Mailbox>> {
        const response = await this.referralPrototypeGetRefereeMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries referrer of CourierUser.
     */
    async referralPrototypeGetRefereeReferrerRaw(requestParameters: ReferralPrototypeGetRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierUser>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefereeReferrer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierUserFromJSON));
    }

    /**
     * Queries referrer of CourierUser.
     */
    async referralPrototypeGetRefereeReferrer(requestParameters: ReferralPrototypeGetRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierUser>> {
        const response = await this.referralPrototypeGetRefereeReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries roleMappings of CourierUser.
     */
    async referralPrototypeGetRefereeRoleMappingsRaw(requestParameters: ReferralPrototypeGetRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleMapping>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefereeRoleMappings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleMappingFromJSON));
    }

    /**
     * Queries roleMappings of CourierUser.
     */
    async referralPrototypeGetRefereeRoleMappings(requestParameters: ReferralPrototypeGetRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleMapping>> {
        const response = await this.referralPrototypeGetRefereeRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries roles of CourierUser.
     */
    async referralPrototypeGetRefereeRolesRaw(requestParameters: ReferralPrototypeGetRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Role>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefereeRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleFromJSON));
    }

    /**
     * Queries roles of CourierUser.
     */
    async referralPrototypeGetRefereeRoles(requestParameters: ReferralPrototypeGetRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Role>> {
        const response = await this.referralPrototypeGetRefereeRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation referer.
     */
    async referralPrototypeGetRefererRaw(requestParameters: ReferralPrototypeGetRefererRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetReferer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation referer.
     */
    async referralPrototypeGetReferer(requestParameters: ReferralPrototypeGetRefererRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.referralPrototypeGetRefererRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries accessTokens of CourierUser.
     */
    async referralPrototypeGetRefererAccessTokensRaw(requestParameters: ReferralPrototypeGetRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccessToken>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefererAccessTokens().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccessTokenFromJSON));
    }

    /**
     * Queries accessTokens of CourierUser.
     */
    async referralPrototypeGetRefererAccessTokens(requestParameters: ReferralPrototypeGetRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccessToken>> {
        const response = await this.referralPrototypeGetRefererAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries courierPackages of CourierUser.
     */
    async referralPrototypeGetRefererCourierPackagesRaw(requestParameters: ReferralPrototypeGetRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierPackage>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefererCourierPackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierPackageFromJSON));
    }

    /**
     * Queries courierPackages of CourierUser.
     */
    async referralPrototypeGetRefererCourierPackages(requestParameters: ReferralPrototypeGetRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierPackage>> {
        const response = await this.referralPrototypeGetRefererCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries invoices of CourierUser.
     */
    async referralPrototypeGetRefererInvoicesRaw(requestParameters: ReferralPrototypeGetRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Invoice>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefererInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceFromJSON));
    }

    /**
     * Queries invoices of CourierUser.
     */
    async referralPrototypeGetRefererInvoices(requestParameters: ReferralPrototypeGetRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Invoice>> {
        const response = await this.referralPrototypeGetRefererInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries mailboxes of CourierUser.
     */
    async referralPrototypeGetRefererMailboxesRaw(requestParameters: ReferralPrototypeGetRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Mailbox>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefererMailboxes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/mailboxes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MailboxFromJSON));
    }

    /**
     * Queries mailboxes of CourierUser.
     */
    async referralPrototypeGetRefererMailboxes(requestParameters: ReferralPrototypeGetRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Mailbox>> {
        const response = await this.referralPrototypeGetRefererMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries referrer of CourierUser.
     */
    async referralPrototypeGetRefererReferrerRaw(requestParameters: ReferralPrototypeGetRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierUser>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefererReferrer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierUserFromJSON));
    }

    /**
     * Queries referrer of CourierUser.
     */
    async referralPrototypeGetRefererReferrer(requestParameters: ReferralPrototypeGetRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierUser>> {
        const response = await this.referralPrototypeGetRefererReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries roleMappings of CourierUser.
     */
    async referralPrototypeGetRefererRoleMappingsRaw(requestParameters: ReferralPrototypeGetRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleMapping>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefererRoleMappings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleMappingFromJSON));
    }

    /**
     * Queries roleMappings of CourierUser.
     */
    async referralPrototypeGetRefererRoleMappings(requestParameters: ReferralPrototypeGetRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleMapping>> {
        const response = await this.referralPrototypeGetRefererRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries roles of CourierUser.
     */
    async referralPrototypeGetRefererRolesRaw(requestParameters: ReferralPrototypeGetRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Role>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeGetRefererRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleFromJSON));
    }

    /**
     * Queries roles of CourierUser.
     */
    async referralPrototypeGetRefererRoles(requestParameters: ReferralPrototypeGetRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Role>> {
        const response = await this.referralPrototypeGetRefererRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a related item by id for roles.
     */
    async referralPrototypeLinkRefereeRolesRaw(requestParameters: ReferralPrototypeLinkRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeLinkRefereeRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeLinkRefereeRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Add a related item by id for roles.
     */
    async referralPrototypeLinkRefereeRoles(requestParameters: ReferralPrototypeLinkRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.referralPrototypeLinkRefereeRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a related item by id for roles.
     */
    async referralPrototypeLinkRefererRolesRaw(requestParameters: ReferralPrototypeLinkRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeLinkRefererRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeLinkRefererRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Add a related item by id for roles.
     */
    async referralPrototypeLinkRefererRoles(requestParameters: ReferralPrototypeLinkRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.referralPrototypeLinkRefererRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async referralPrototypePatchAttributesRaw(requestParameters: ReferralPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Referral>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async referralPrototypePatchAttributes(requestParameters: ReferralPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Referral> {
        const response = await this.referralPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove the roles relation to an item by id.
     */
    async referralPrototypeUnlinkRefereeRolesRaw(requestParameters: ReferralPrototypeUnlinkRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUnlinkRefereeRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUnlinkRefereeRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referee/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove the roles relation to an item by id.
     */
    async referralPrototypeUnlinkRefereeRoles(requestParameters: ReferralPrototypeUnlinkRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeUnlinkRefereeRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Remove the roles relation to an item by id.
     */
    async referralPrototypeUnlinkRefererRolesRaw(requestParameters: ReferralPrototypeUnlinkRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUnlinkRefererRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUnlinkRefererRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Referrals/{id}/referer/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove the roles relation to an item by id.
     */
    async referralPrototypeUnlinkRefererRoles(requestParameters: ReferralPrototypeUnlinkRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.referralPrototypeUnlinkRefererRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Update a related item by id for accessTokens.
     */
    async referralPrototypeUpdateByIdRefereeAccessTokensRaw(requestParameters: ReferralPrototypeUpdateByIdRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefereeAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefereeAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccessTokenToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for accessTokens.
     */
    async referralPrototypeUpdateByIdRefereeAccessTokens(requestParameters: ReferralPrototypeUpdateByIdRefereeAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.referralPrototypeUpdateByIdRefereeAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for courierPackages.
     */
    async referralPrototypeUpdateByIdRefereeCourierPackagesRaw(requestParameters: ReferralPrototypeUpdateByIdRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefereeCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefereeCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierPackageToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for courierPackages.
     */
    async referralPrototypeUpdateByIdRefereeCourierPackages(requestParameters: ReferralPrototypeUpdateByIdRefereeCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.referralPrototypeUpdateByIdRefereeCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for invoices.
     */
    async referralPrototypeUpdateByIdRefereeInvoicesRaw(requestParameters: ReferralPrototypeUpdateByIdRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefereeInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefereeInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for invoices.
     */
    async referralPrototypeUpdateByIdRefereeInvoices(requestParameters: ReferralPrototypeUpdateByIdRefereeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.referralPrototypeUpdateByIdRefereeInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for mailboxes.
     */
    async referralPrototypeUpdateByIdRefereeMailboxesRaw(requestParameters: ReferralPrototypeUpdateByIdRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Mailbox>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefereeMailboxes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefereeMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/mailboxes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailboxToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for mailboxes.
     */
    async referralPrototypeUpdateByIdRefereeMailboxes(requestParameters: ReferralPrototypeUpdateByIdRefereeMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Mailbox> {
        const response = await this.referralPrototypeUpdateByIdRefereeMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for referrer.
     */
    async referralPrototypeUpdateByIdRefereeReferrerRaw(requestParameters: ReferralPrototypeUpdateByIdRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefereeReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefereeReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierUserToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for referrer.
     */
    async referralPrototypeUpdateByIdRefereeReferrer(requestParameters: ReferralPrototypeUpdateByIdRefereeReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.referralPrototypeUpdateByIdRefereeReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for roleMappings.
     */
    async referralPrototypeUpdateByIdRefereeRoleMappingsRaw(requestParameters: ReferralPrototypeUpdateByIdRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefereeRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefereeRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for roleMappings.
     */
    async referralPrototypeUpdateByIdRefereeRoleMappings(requestParameters: ReferralPrototypeUpdateByIdRefereeRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.referralPrototypeUpdateByIdRefereeRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for roles.
     */
    async referralPrototypeUpdateByIdRefereeRolesRaw(requestParameters: ReferralPrototypeUpdateByIdRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefereeRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefereeRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referee/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for roles.
     */
    async referralPrototypeUpdateByIdRefereeRoles(requestParameters: ReferralPrototypeUpdateByIdRefereeRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.referralPrototypeUpdateByIdRefereeRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for accessTokens.
     */
    async referralPrototypeUpdateByIdRefererAccessTokensRaw(requestParameters: ReferralPrototypeUpdateByIdRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefererAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefererAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccessTokenToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for accessTokens.
     */
    async referralPrototypeUpdateByIdRefererAccessTokens(requestParameters: ReferralPrototypeUpdateByIdRefererAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.referralPrototypeUpdateByIdRefererAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for courierPackages.
     */
    async referralPrototypeUpdateByIdRefererCourierPackagesRaw(requestParameters: ReferralPrototypeUpdateByIdRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefererCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefererCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierPackageToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for courierPackages.
     */
    async referralPrototypeUpdateByIdRefererCourierPackages(requestParameters: ReferralPrototypeUpdateByIdRefererCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.referralPrototypeUpdateByIdRefererCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for invoices.
     */
    async referralPrototypeUpdateByIdRefererInvoicesRaw(requestParameters: ReferralPrototypeUpdateByIdRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefererInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefererInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for invoices.
     */
    async referralPrototypeUpdateByIdRefererInvoices(requestParameters: ReferralPrototypeUpdateByIdRefererInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.referralPrototypeUpdateByIdRefererInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for mailboxes.
     */
    async referralPrototypeUpdateByIdRefererMailboxesRaw(requestParameters: ReferralPrototypeUpdateByIdRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Mailbox>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefererMailboxes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefererMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/mailboxes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailboxToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for mailboxes.
     */
    async referralPrototypeUpdateByIdRefererMailboxes(requestParameters: ReferralPrototypeUpdateByIdRefererMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Mailbox> {
        const response = await this.referralPrototypeUpdateByIdRefererMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for referrer.
     */
    async referralPrototypeUpdateByIdRefererReferrerRaw(requestParameters: ReferralPrototypeUpdateByIdRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefererReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefererReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierUserToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for referrer.
     */
    async referralPrototypeUpdateByIdRefererReferrer(requestParameters: ReferralPrototypeUpdateByIdRefererReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.referralPrototypeUpdateByIdRefererReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for roleMappings.
     */
    async referralPrototypeUpdateByIdRefererRoleMappingsRaw(requestParameters: ReferralPrototypeUpdateByIdRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefererRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefererRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for roleMappings.
     */
    async referralPrototypeUpdateByIdRefererRoleMappings(requestParameters: ReferralPrototypeUpdateByIdRefererRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.referralPrototypeUpdateByIdRefererRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for roles.
     */
    async referralPrototypeUpdateByIdRefererRolesRaw(requestParameters: ReferralPrototypeUpdateByIdRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateByIdRefererRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling referralPrototypeUpdateByIdRefererRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/referer/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for roles.
     */
    async referralPrototypeUpdateByIdRefererRoles(requestParameters: ReferralPrototypeUpdateByIdRefererRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.referralPrototypeUpdateByIdRefererRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update courierSetting of this model.
     */
    async referralPrototypeUpdateCourierCourierSettingRaw(requestParameters: ReferralPrototypeUpdateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Update courierSetting of this model.
     */
    async referralPrototypeUpdateCourierCourierSetting(requestParameters: ReferralPrototypeUpdateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.referralPrototypeUpdateCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update mailOption of this model.
     */
    async referralPrototypeUpdateCourierMailOptionRaw(requestParameters: ReferralPrototypeUpdateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralPrototypeUpdateCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Update mailOption of this model.
     */
    async referralPrototypeUpdateCourierMailOption(requestParameters: ReferralPrototypeUpdateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.referralPrototypeUpdateCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async referralReplaceByIdPostReferralsidReplaceRaw(requestParameters: ReferralReplaceByIdPostReferralsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Referral>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralReplaceByIdPostReferralsidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async referralReplaceByIdPostReferralsidReplace(requestParameters: ReferralReplaceByIdPostReferralsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Referral> {
        const response = await this.referralReplaceByIdPostReferralsidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async referralReplaceByIdPutReferralsidRaw(requestParameters: ReferralReplaceByIdPutReferralsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Referral>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling referralReplaceByIdPutReferralsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async referralReplaceByIdPutReferralsid(requestParameters: ReferralReplaceByIdPutReferralsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Referral> {
        const response = await this.referralReplaceByIdPutReferralsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async referralReplaceOrCreatePostReferralsReplaceOrCreateRaw(requestParameters: ReferralReplaceOrCreatePostReferralsReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Referral>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async referralReplaceOrCreatePostReferralsReplaceOrCreate(requestParameters: ReferralReplaceOrCreatePostReferralsReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Referral> {
        const response = await this.referralReplaceOrCreatePostReferralsReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async referralReplaceOrCreatePutReferralsRaw(requestParameters: ReferralReplaceOrCreatePutReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Referral>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async referralReplaceOrCreatePutReferrals(requestParameters: ReferralReplaceOrCreatePutReferralsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Referral> {
        const response = await this.referralReplaceOrCreatePutReferralsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async referralUpdateAllRaw(requestParameters: ReferralUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async referralUpdateAll(requestParameters: ReferralUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.referralUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async referralUpsertWithWhereRaw(requestParameters: ReferralUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Referral>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Referrals/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async referralUpsertWithWhere(requestParameters: ReferralUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Referral> {
        const response = await this.referralUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
